// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './common/css/reset.scss'
//import fastClick from 'fastclick'
import libFlexible from 'lib-flexible'
import VueLazyload from 'vue-lazyload'
import 'font-awesome/css/font-awesome.min.css'

Vue.use(VueLazyload,{
    loading: require('./common/img/loadingimg.jpg')
})

Vue.config.productionTip = false
//fastClick.attach(document.body)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
})



// WEBPACK FOOTER //
// ./src/main.js